import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { isNull } from 'lodash'
import MediaQuery from 'react-responsive'
import Dialog from 'material-ui/Dialog'
import AddCircle from 'material-ui/svg-icons/content/add-circle'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import FlatButton from 'material-ui/FlatButton'
import Delete from 'material-ui/svg-icons/action/delete'
import ContentAdd from 'material-ui/svg-icons/content/add'
import WayPoint from 'react-waypoint'
import Spinner from '../../common/Spinner'
import ListCard from '../../common/ListCard'
import NoResults from '../../common/NoResults'
import AddItemForm from '../../common/AddItemForm'
import {
  loadInterestItems,
  loadMoreInterestItems,
  unloadInterestItems,
  removeInterest,
} from '../../actions'
import {
  getInterestItems,
  canLoadMoreInterestItems,
  getTotalInterestItems,
  getInterestItemsLoading,
} from '../../selectors'
import { makeAuthenticatedApi } from '../../api'
import { parseQ, itemLink, prepareNewItemForApi } from '../../utils'
import { handleSumbissionErrors } from '../../form/errors'
import breakpoints from '../../styles/breakpoints'
import { themeColors } from '../../styles/theme'

const styles = {
  addInterestButton: {
    position: 'fixed',
    bottom: '65px',
    right: '10px',
  },
  addInterestButtonMobile: {
    position: 'fixed',
    top: '110px',
    right: '10px',
  },
  favoriteBorder: {
    color: themeColors.positive,
    position: 'relative',
    top: 7,
  },
  removeBtn: {
    marginLeft: 'auto',
    minWidth: 45,
    position: 'relative',
    top: 10,
    marginBottom: 5,
  },
}

class IntrestItems extends PureComponent {
  state = {
    showAddIterestForm: false,
    itemToRemove: null,
  }

  componentDidMount() {
    this.props.loadInterestItems({
      q: this.props.searchString,
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchString !== nextProps.searchString) {
      this.props.unloadInterestItems()
      this.props.loadInterestItems({
        q: nextProps.searchString,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadInterestItems()
  }

  loadMore = () => {
    this.props.loadMoreInterestItems({
      q: this.props.searchString,
    })
  }

  toggleShowAddInterestForm = () => {
    this.setState(state => ({ showAddIterestForm: !state.showAddIterestForm }))
  }

  handleSubmitInterest = itemInterest => {
    const newInterestForApi = prepareNewItemForApi(itemInterest)
    return this.props.api
      .addInterest(newInterestForApi)
      .catch(handleSumbissionErrors)
  }

  handleSubmitInterestSuccess = itemInterest => {
    // Reload interests when new added success
    this.props.unloadInterestItems()
    this.props.loadInterestItems({
      q: this.props.searchString,
    })
    this.toggleShowAddInterestForm()
  }

  askRemoveItem = item => this.setState({ itemToRemove: item })

  dismissItemRemoveDialog = () => this.setState({ itemToRemove: null })

  goToItemDetail = item => {
    this.props.history.push(itemLink(item), {
      isUserInterest: true,
    })
  }

  render() {
    const { items, loading, searchString, canLoadMoreItems } = this.props
    return (
      <div>
        <MediaQuery maxWidth={breakpoints.xs}>
          {matches => (
            <FloatingActionButton
              style={
                matches
                  ? styles.addInterestButtonMobile
                  : styles.addInterestButton
              }
              onClick={this.toggleShowAddInterestForm}>
              <ContentAdd />
            </FloatingActionButton>
          )}
        </MediaQuery>

        {/* Loading items spinner */}
        {loading && isNull(items) && <Spinner centered />}

        {/*  No results for searching */}
        {!loading &&
          !isNull(items) &&
          items.length === 0 &&
          searchString !== '' &&
          <NoResults>
            Nessun oggetto per la ricerca <b><i>{searchString}</i></b>
          </NoResults>}

        {/*  No items interested */}
        {!loading &&
          !isNull(items) &&
          items.length === 0 &&
          !searchString &&
          <NoResults>
            Clicca sul bottone a destra
            {' '}
            <AddCircle style={styles.favoriteBorder} />
            {' '}
            per aggiungere informazioni su ciò che desideri
          </NoResults>}

        {!isNull(items) &&
          items.length > 0 &&
          <div>
            {items.map(item => (
              <ListCard
                onClick={this.goToItemDetail}
                key={item.id}
                item={item}
                rightButton={
                  <div>
                    <FlatButton
                      icon={<Delete style={{ fill: themeColors.neutral }} />}
                      style={styles.removeBtn}
                      onClick={e => {
                        e.stopPropagation()
                        this.askRemoveItem(item)
                      }}
                    />
                  </div>
                }
              />
            ))}
          </div>}

        {/*  Loading more items spinner */}
        {loading && !isNull(items) && items.length > 0 && <Spinner centered />}

        {/* Trigger load more */}
        {!loading &&
          !isNull(items) &&
          items.length > 0 &&
          canLoadMoreItems &&
          <WayPoint onEnter={this.loadMore} />}

        <Dialog
          title="Aggiungi Interesse"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={this.state.showAddIterestForm}
          onRequestClose={this.toggleShowAddInterestForm}
          autoScrollBodyContent={true}>
          <div style={{ height: '80vh' }}>
            <AddItemForm
              style={{ paddingBottom: '10px' }}
              interest={true}
              onSubmit={this.handleSubmitInterest}
              onSubmitSuccess={this.handleSubmitInterestSuccess}
            />
          </div>
        </Dialog>

        <Dialog
          title="Rimuovi Interesse"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={!isNull(this.state.itemToRemove)}
          onRequestClose={this.dismissItemRemoveDialog}
          actions={[
            <FlatButton
              label="Annulla"
              primary={true}
              onClick={this.dismissItemRemoveDialog}
            />,
            <FlatButton
              label="Ok"
              primary={true}
              keyboardFocused={true}
              onClick={() => {
                this.props.removeInterest(this.state.itemToRemove)
                this.dismissItemRemoveDialog()
              }}
            />,
          ]}>
          {this.state.itemToRemove &&
            <p>
              Rimuovere interesse {this.state.itemToRemove.titolo}?
            </p>}
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  // Parse the query string ?q= into a string take care of null boring stuff
  api: makeAuthenticatedApi(state),
  searchString: parseQ(ownProps.location),
  items: getInterestItems(state),
  totalItems: getTotalInterestItems(state),
  canLoadMoreItems: canLoadMoreInterestItems(state),
  loading: getInterestItemsLoading(state),
})

export default connect(mapStateToProps, {
  loadInterestItems,
  loadMoreInterestItems,
  unloadInterestItems,
  removeInterest,
})(IntrestItems)



// WEBPACK FOOTER //
// ./src/pages/Me/InterestItems.js